import MenuAndRoutesBuilder from '../../menuAndRoutesBuilder'

export const GetPodatkiIzbirnika = {
  data () {
    return {
      seznamPodatkov: { data: [], selectorData: [] },
      menuAndRoutesBuilder: MenuAndRoutesBuilder.getInstance()
    }
  },
  methods: {
    PridobiPodatkeIzbirnika (prenosniParam) {
      let permissionsArray = []
      let currentRoute = this.$router.currentRoute.path
      let callBackInterface = this
      this.menuAndRoutesBuilder.FindPathInRoutes(currentRoute, true).then(routeData => {
        if (typeof prenosniParam.permissions !== 'undefined' && prenosniParam.permissions !== null &&
          prenosniParam.permissions.constructor === Array) {
          permissionsArray = prenosniParam.permissions
          if (routeData && routeData.defaultConnectorType !== null &&
            typeof routeData.defaultConnectorType !== 'undefined') {
            prenosniParam.defaultConnectorType = routeData.defaultConnectorType
          }
        } else {
          /* pravica ni bila podana, preverimo pravice v routes za to stran */
          if (routeData) {
            if (routeData.permissions.length > 0) {
              permissionsArray = routeData.permissions
            }
            if (routeData.defaultConnectorType !== null && typeof routeData.defaultConnectorType !== 'undefined') {
              prenosniParam.defaultConnectorType = routeData.defaultConnectorType
            }
          }
        }
        for (let i = 0; i < permissionsArray.length; i++) {
          let permission = permissionsArray[i]
          let permissionData = this.menuAndRoutesBuilder.StripPermission(permission)
          if (permissionData !== false) {
            let param = ['permissionId=' + permissionData.permission]
            if (typeof prenosniParam.filter !== 'undefined' && prenosniParam.filter !== null) {
              param.push('filter[' + prenosniParam.filter.filter_name + ']=' + prenosniParam.filter.filter_value)
            }
            this.clientAgent.postWsRequest(callBackInterface,
              'permissions/havePermission?',
              param,
              prenosniParam,
              'SetPodatki',
              'ErrPodatki')
          }
        }
      })
    },
    SetPodatki (podatki, prenosniParam) {
      if (typeof podatki.permission !== 'undefined') {
        if (podatki.permission.selector !== null) {
          this.seznamPodatkov.selectorData = this.seznamPodatkov.selectorData.concat(podatki.permission.selector)
          this.seznamPodatkov.selectorData = this.seznamPodatkov.selectorData.filter((selector, index, self) =>
            index === self.findIndex((s) => (
              s.id === selector.id
            ))
          )
        }
        /* eslint-disable */
        if (podatki.permission.additionalData !== null) {
          this.seznamPodatkov.data = this.seznamPodatkov.data.concat(podatki.permission.additionalData)
          this.seznamPodatkov.data = this.seznamPodatkov.data.filter((result, index, self) =>
              index === self.findIndex((s) => (
                s.selector_id === result.selector_id
              ))
          )
        }
        /* eslint-enable */
      }
      let vmesnik = prenosniParam.vmesnik
      if (typeof prenosniParam.callbackFunction === 'function') {
        prenosniParam.callbackFunction(this.seznamPodatkov)
      } else {
        vmesnik.PrenosniPodatki(this.seznamPodatkov, prenosniParam)
      }
    },
    ErrPodatki (podatki) {
      let paramObvestilo = {}
      paramObvestilo.message = podatki.message
      this.ShowWarningMessage(paramObvestilo)
    },
    GetPrivzeteVrednosti () {

    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/globalne_funkcije/SplosneGlobalneFunkcije/GetPodatkiIzbirnika.js